import { SRS_INTERVALS_MS } from "./constants.js";

/**
 * Seedable RNG (mulberry32). Identical seed → identical level layout for all
 * players in the same multiplayer race.
 */
export function createRng(seed: number) {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function shuffle<T>(arr: readonly T[], rng: () => number = Math.random): T[] {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [out[i], out[j]] = [out[j]!, out[i]!];
  }
  return out;
}

/** SM-2-lite. Returns the next srsLevel and dueAt timestamp. */
export function nextSrsState(opts: {
  srsLevel: number;
  correct: boolean;
  now: number;
}): { srsLevel: number; srsDueAt: number } {
  const max = SRS_INTERVALS_MS.length - 1;
  const nextLevel = opts.correct
    ? Math.min(max, opts.srsLevel + 1)
    : Math.max(0, opts.srsLevel - 1);
  return {
    srsLevel: nextLevel,
    srsDueAt: opts.now + SRS_INTERVALS_MS[nextLevel]!,
  };
}
